<template>
  <div class="mt-1" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <export-options
        :exportUrl="exportUrl"
        :repository="repository"
        :resource="resource"
        :tableRef="$refs[tableRef]"
        :filter="filter"
        :options="[
          {
            code: 'LISTABB',
            label: null,
            formats: ['csv', 'pdf'],
          },
        ]"
      ></export-options>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item" data-cols="2">
              <base-datepicker
                name="book_date"
                label="Data Registrazione Dal"
                v-model="filter.byCalendar.from"
              />
              <base-datepicker
                name="book_date"
                label="Data Registrazione al"
                v-model="filter.byCalendar.to"
              />
            </div>
            <div class="filter-item">
              <base-select
                name="cod_prod"
                label="Produttore"
                :options="salesmen_select"
                v-model="filter.byBroker.id"
                :multiple="true"
                :closeOnSelect="false"
                :taggable="salesmen_taggable"
                :defaultHtmlMultipleSelect="true"
                @changeTaggable="changeTaggable"
              >
                <template #advanced-actions>
                  <b-button
                    :pressed.sync="myToggle"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="myToggle ? selectAllBrokers() : deselectAllBrokers()"
                    >{{ myToggle ? "Deseleziona tutti" : "Seleziona tutti" }}
                  </b-button>
                  <b-button
                    :pressed.sync="myTogglePO"
                    variant="light"
                    class="btn--smaller btn--x-smaller btn--transparent"
                    @click="
                      myTogglePO ? salesmenOrderByCode() : salesmenOrderByName()
                    "
                    >{{ myTogglePO ? "Ordine per nome" : "Ordina per codice" }}
                  </b-button>
                </template>
              </base-select>
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>

      <!-- REVIEW story-36-a: enable this when BE can handle sort requests!!! -->
      <!-- sortField="book_date" -->

      <book-entries
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        :filterOn="{
          bySector: { display: 'ABB' },
          byRelations: [
            'byBroker',
            'byDocument',
            'byTask',
            'byRegistry',
            'byInsurer',
            'byInsuranceAncillary',
            'byVariousAccounting',
            'byBookTag',
          ],
        }"
        :filterName="filterName"
        :ref="tableRef"
        :hasChecksButtonGroup="false"
        noActions
        :extraFooter="rebate_entry"
        sortField="book_date"
      ></book-entries>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import BookEntries from "@/components/tables/BookEntries";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import { mapActions } from "vuex";
import { toLocaleDate } from "@/utils/dates";
import { toInfoData } from "@/utils/transforms";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters } from "vuex";
import BaseSelect from "@/components/form/BaseSelect";
import ExportOptions from "@/components/ExportOptions";
import BaseIcon from "@/components/BaseIcon";
import sidebarFilterMixin from "../../../../mixins/SidebarFilterMixin";

export default {
  mixins: [CustomFiltersMixin, sidebarFilterMixin],
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      filterName: "filterBookEntryRebate",
      resource: "book_entries",
      repository: "book_entry",
      tableRef: "BookEntryRebateTableRef",
      performedSearch: false,
      rebate_entry: {},
      activeFilters: {},
      salesmen: [],
      salesmen_taggable: true,
      myToggle: false,
      myTogglePO: false,
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_ids: [], // i produttori della tendina multipla
      salesman_id: null,
      cooperators: [],
      risk_branches: [],
      companies: [],
      products: [],
      risks: [],
      book_tags_opt: [],
      notes: [],
      documents: [],
      registry_data: null,
      insurance_policy_data: null,
      form: {
        inpt_label_policy: "",
        inpt_label_registry: "",
        quick_value: "",
      },
      fields: [
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          formatter: (value) => toLocaleDate(value),
        },
        {
          key: "title",
          label: this.getDictionary("title", "book_entry"),
        },
        {
          key: "broker",
          label: this.getDictionary("broker", "book_entry"),
        },
        {
          key: "pos_rebate",
          label: this.getDictionary("pos_rebate", "book_entry"),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
        {
          key: "neg_rebate",
          label: this.getDictionary("neg_rebate", "book_entry"),
          thClass: "text-right",
          thStyle: {
            "text-align": "right",
          },
          tdClass: "text-right",
        },
      ],
    };
  },
  components: {
    BaseIcon,
    BaseDatepicker,
    BookEntries,
    BaseSelect,
    ExportOptions,
  },
  computed: {
    computePerformedSearch() {
      return this.performedSearch;
    },
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
  },
  methods: {
    toInfoData,
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    initFilter() {
      let init = {
        byCalendar: {
          from: null,
          to: null,
        },
        byBroker: {
          id: null,
        },
      };
      return init;
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllBrokers() {
      this.filter.byBroker.id = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllBrokers() {
      this.filter.byBroker.id = [];
      this.salesman_id = null;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.fetchSummary();
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
    },
    fetchSummary() {
      const Repo = RepositoryFactory.get("sector");
      let sectors = this.getSectors();
      const rebate_id = sectors.find((sector) => sector.code === "AB").value;
      const broker = this.filter.byBroker.id
        ? `&byBroker[id]=${this.filter.byBroker.id}`
        : ``;
      Repo.summary(
        `byAttribute[id]=${rebate_id}${broker}&byCalendar=${this.filter.byCalendar.from},${this.filter.byCalendar.to}`,
      )
        .then((response) => {
          this.rebate_entry = {
            entry_in: response.data.data[0].entry_in,
            entry_out: response.data.data[0].entry_out,
          };
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("auth", {
      // allTreasuries: "allTreasuries",
      getSectors: "sectors",
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
    }),
    ...mapGetters("filters", { loadFilterByName: "loadByName" }),
  },
  mounted() {
    if (this.loadFilterByName()(this.filterName)) {
      this.fetchSummary();
    }
    this.salesmen = this.getSalesmen();
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
  },
};
</script>
